"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addToArrayKeepingMostRecentItems = void 0;
const addToArrayKeepingMostRecentItems = (array, item, maxLength) => {
    // add new item to front and pull last item off if array is too long
    array.unshift(item);
    if (array.length > maxLength) {
        array.pop();
    }
};
exports.addToArrayKeepingMostRecentItems = addToArrayKeepingMostRecentItems;
//# sourceMappingURL=array_helpers.js.map